import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Collapse from './Collapse';
import Button from './Button';
import Text from './Text';
import Div from './Div';

const MessageAlerts = ({
  messages,
  onSnooze,
  onAction,
  buttonCloseText,
  buttonOpenText,
  noMessagesCopy,
  showUnreadMessageCount,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Collapse
        isOpen={isOpen}
        pos="fixed"
        bottom="24px"
        right="32px"
        flexDir="column"
        bg="brand100"
        w="640px"
        shadow="5"
        rounded="md"
      >
        <>
          {messages.length > 0 ? (
            messages.map((message, index) => (
              <Div p={{ x: '16px', y: '8px' }}>
                <Text p={{ b: '8px' }} textSize="subheader">
                  {message}
                </Text>
                <Div d="flex" justify="space-between">
                  <Button onClick={() => onSnooze(index)} bg="gray200" textColor="medium" m={{ r: '16px' }} h="24px">
                    Snooze
                  </Button>
                  <Button onClick={() => onAction(index)} bg="info700" h="24px">
                    Take Action
                  </Button>
                </Div>
              </Div>
            ))
          ) : (
            <Text textSize="subheader">{noMessagesCopy}</Text>
          )}
        </>
      </Collapse>
      <Button
        pos="fixed"
        bottom="0px"
        right="32px"
        onClick={() => setIsOpen(!isOpen)}
        rounded={{ tl: 'md', tr: 'md' }}
        h="40px"
        w="128px"
        shadow="3"
        bg="brand500"
      >
        {isOpen
          ? buttonCloseText
          : showUnreadMessageCount && messages.length
            ? `${buttonOpenText}(${messages.length})`
            : buttonOpenText}
      </Button>
    </>
  );
};

MessageAlerts.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSnooze: PropTypes.func.isRequired,
  onAction: PropTypes.func.isRequired,
  buttonOpenText: PropTypes.string,
  buttonCloseText: PropTypes.string,
  noMessagesCopy: PropTypes.string,
  showUnreadMessageCount: PropTypes.bool,
};

MessageAlerts.defaultProps = {
  buttonOpenText: 'Messages',
  buttonCloseText: 'Hide',
  noMessagesCopy: 'You have no unread messages',
  showUnreadMessageCount: true,
};

export default MessageAlerts;
